
.hs-hero *,
.hs-hero *::before,
.hs-hero *::after {
  box-sizing: border-box;
}

.hs-hero img {
  display: block;
  max-width: 100%;
}

.hs-hero {
  position: relative;
  min-height: 600px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #fafafb 0%, #ffffff 100%);
  color: #0a0a0a;
}

.hs-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(10, 10, 10, 0.055) 1px, transparent 1px),
    linear-gradient(90deg, rgba(10, 10, 10, 0.055) 1px, transparent 1px);
  background-size: 56px 56px;
  background-position: -1px -1px;
  mask-image: radial-gradient(ellipse at 50% 45%, rgba(0, 0, 0, 0.85) 0%, transparent 75%);
  -webkit-mask-image: radial-gradient(ellipse at 50% 45%, rgba(0, 0, 0, 0.85) 0%, transparent 75%);
  pointer-events: none;
  z-index: 1;
  transform: translateZ(0);
}

.hs-glow {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, transparent 0%, transparent 85%, rgba(222, 52, 49, 0.06) 100%),
    radial-gradient(circle at 50% 50%, rgba(222, 52, 49, 0.03), transparent 70%);
  pointer-events: none;
  z-index: 2;
}

.hs-hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(222, 52, 49, 0) 10%,
    rgba(222, 52, 49, 0.35) 50%,
    rgba(222, 52, 49, 0) 90%,
    transparent 100%
  );
  pointer-events: none;
  z-index: 3;
}

.hs-brackets {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 3;
}
.hs-bracket {
  position: absolute;
  width: 38px;
  height: 38px;
  border: 1.5px solid rgba(222, 52, 49, 0.55);
}
.hs-bracket-tl { top: 22px; left: 22px; border-right: none; border-bottom: none; }
.hs-bracket-tr { top: 22px; right: 22px; border-left: none; border-bottom: none; }
.hs-bracket-bl { bottom: 22px; left: 22px; border-right: none; border-top: none; }
.hs-bracket-br { bottom: 22px; right: 22px; border-left: none; border-top: none; }

.hs-constellation {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
  display: block;
  transform: translateZ(0);
  mask-image: radial-gradient(
    ellipse 42% 55% at 50% 50%,
    transparent 0%,
    transparent 55%,
    rgba(0, 0, 0, 0.6) 80%,
    #000 100%
  );
  -webkit-mask-image: radial-gradient(
    ellipse 42% 55% at 50% 50%,
    transparent 0%,
    transparent 55%,
    rgba(0, 0, 0, 0.6) 80%,
    #000 100%
  );
}

.hs-plus {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 2;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 112 112'><g stroke='%23de3431' stroke-width='1.1' opacity='0.4' stroke-linecap='round'><line x1='56' y1='52' x2='56' y2='60'/><line x1='52' y1='56' x2='60' y2='56'/></g></svg>");
  background-size: 112px 112px;
  mask-image: radial-gradient(ellipse at 50% 45%, rgba(0, 0, 0, 0.8) 0%, transparent 75%);
  -webkit-mask-image: radial-gradient(ellipse at 50% 45%, rgba(0, 0, 0, 0.8) 0%, transparent 75%);
  transform: translateZ(0);
}

/* === Credibility bar === */

.hs-trust-bar {
  padding: 0.6rem 0.75rem;
  background: #0a0a0a;
  text-align: center;
  font-family: "Rajdhani", Arial, sans-serif;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.hs-trust-heading {
  margin: 0;
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #c8c8d0;
}

.hs-trust-heading-accent {
  color: #de3431;
}

@media (max-width: 540px) {
  .hs-trust-bar { padding: 0.5rem; }
  .hs-trust-heading {
    font-size: 0.85rem;
    letter-spacing: 0.12em;
  }
}

.hs-hero::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 18%;
  background: linear-gradient(to top, #ffffff 0%, #ffffff 20%, rgba(255, 255, 255, 0) 100%);
  pointer-events: none;
  z-index: 5;
}

/* === SPLIT LAYOUT (desktop) === */
.hs-hero-inner {
  position: relative;
  width: 100%;
  max-width: 1180px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  column-gap: 2rem;
  align-items: center;
  z-index: 10;
  padding: 1.5rem 1.5rem 0;
}

.hs-text-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  z-index: 20;
}

.hs-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  font-family: "Rajdhani", Arial, sans-serif;
  font-weight: 600;
  font-size: 0.82rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #4a4a55;
  padding: 0.45rem 0.95rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(10, 10, 10, 0.08);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 2px 10px rgba(10, 10, 10, 0.04);
  margin-bottom: 1rem;
  z-index: 20;
}

.hs-eyebrow-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #de3431;
  box-shadow: 0 0 10px rgba(222, 52, 49, 0.6);
  animation: hsPulse 2.2s ease-in-out infinite;
}

@keyframes hsPulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.55; transform: scale(0.85); }
}

.hs-hero-title {
  text-align: left;
  margin: 0;
  z-index: 20;
  pointer-events: none;
  will-change: transform;
  animation: hs-float-title 14s ease-in-out infinite;
}

.hs-hero-title-main {
  display: block;
  font-family: "Rajdhani", Arial, sans-serif;
  font-size: clamp(2.4rem, 4.8vw, 4rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #0a0a0a;
  line-height: 1.05;
}

.hs-accent {
  background: linear-gradient(135deg, #de3431 0%, #ff6b5a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.hs-hero-title-sub {
  display: block;
  margin-top: 0.6rem;
  font-family: "Rajdhani", Arial, sans-serif;
  font-size: clamp(1rem, 1.9vw, 1.45rem);
  font-weight: 500;
  color: #4a4a55;
  letter-spacing: -0.005em;
}

.hs-hero-buttons {
  display: flex;
  gap: 1.25rem;
  margin-top: 2rem;
  justify-content: flex-start;
  z-index: 20;
}

.hs-hero-btn {
  padding: 0.8rem 2rem;
  text-decoration: none;
  font-family: "Rajdhani", Arial, sans-serif;
  font-weight: 700;
  border-radius: 8px;
  transition: all 0.3s ease-in-out;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 1rem;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.hs-hero-btn-primary {
  background: #de3431;
  color: #ffffff;
  border-color: #de3431;
  box-shadow: 0 6px 20px rgba(222, 52, 49, 0.25);
}

.hs-hero-btn-primary:hover {
  background: #0a0a0a;
  border-color: #0a0a0a;
  box-shadow: 0 8px 26px rgba(10, 10, 10, 0.35);
  transform: translateY(-2px);
}

.hs-hero-btn-secondary {
  background: #ffffff;
  color: #0a0a0a;
  border-color: rgba(10, 10, 10, 0.15);
  box-shadow: 0 2px 10px rgba(10, 10, 10, 0.04);
}

.hs-hero-btn-secondary:hover {
  border-color: #0a0a0a;
  box-shadow: 0 6px 20px rgba(10, 10, 10, 0.1);
  transform: translateY(-2px);
}

.hs-spec-strip {
  list-style: none;
  padding: 0.55rem 1.25rem;
  margin: 1.75rem 0 0 0;
  display: inline-flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  gap: 0;
  z-index: 20;
  font-family: "Rajdhani", Arial, sans-serif;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(10, 10, 10, 0.08);
  border-radius: 8px;
  box-shadow:
    0 1px 2px rgba(10, 10, 10, 0.06),
    0 8px 20px rgba(10, 10, 10, 0.1),
    0 20px 40px rgba(10, 10, 10, 0.08);
}

.hs-spec-strip li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0.1rem 1.35rem;
  border-left: 1px solid rgba(10, 10, 10, 0.12);
  min-width: 0;
}

.hs-spec-strip li:first-child {
  border-left: none;
  padding-left: 0;
}

.hs-spec-strip li:last-child {
  padding-right: 0;
}

.hs-spec-label {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #de3431;
  line-height: 1;
  margin-bottom: 0.4rem;
}

.hs-spec-value {
  font-size: 1rem;
  font-weight: 600;
  color: #0a0a0a;
  letter-spacing: -0.005em;
  line-height: 1.1;
  white-space: nowrap;
}

.hs-slot {
  position: relative;
  display: inline-block;
  overflow: hidden;
  height: 1.15em;
  vertical-align: baseline;
}

.hs-slot-gpu { min-width: 18ch; }
.hs-slot-cpu { min-width: 19ch; }

.hs-slot-item {
  position: absolute;
  left: 0;
  top: 0;
  white-space: nowrap;
  will-change: transform, opacity;
  transform: translateZ(0);
  backface-visibility: hidden;
}

@media (prefers-reduced-motion: reduce) {
  .hs-slot-item {
    will-change: auto;
  }
}

.hs-hardware-cluster {
  position: relative;
  width: 100%;
  max-width: 640px;
  height: 450px;
  justify-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hs-pc {
  position: absolute;
  width: clamp(180px, 26vw, 300px);
  cursor: pointer;
  will-change: transform;
}

.hs-pc-inner,
.hs-part-inner {
  width: 100%;
  height: 100%;
  display: block;
  will-change: transform;
}

.hs-pc-front .hs-pc-inner {
  filter: drop-shadow(0 18px 32px rgba(10, 10, 10, 0.18)) drop-shadow(0 0 24px rgba(222, 52, 49, 0.1));
}

.hs-pc-back .hs-pc-inner {
  filter: brightness(0.96) drop-shadow(0 14px 28px rgba(10, 10, 10, 0.14));
}

.hs-part-inner {
  filter: drop-shadow(0 14px 28px rgba(10, 10, 10, 0.16));
}

.hs-pc-back {
  left: clamp(-5%, 0%, 3%);
  top: 5%;
  z-index: 8;
  animation: hs-float-pc-back 12s ease-in-out 1s infinite backwards;
}

.hs-pc-front {
  left: clamp(18%, 25%, 30%);
  top: 18%;
  z-index: 12;
  animation: hs-float-pc-front 11s ease-in-out infinite;
}

.hs-part {
  position: absolute;
  cursor: pointer;
  will-change: transform;
}

.hs-part-gpu-main {
  width: clamp(170px, 18vw, 240px);
  left: clamp(65%, 75%, 82%);
  top: clamp(-18%, -10%, -2%);
  z-index: 25;
  animation: hs-float-gpu 12s ease-in-out infinite;
}

.hs-part-cpu {
  width: clamp(110px, 13vw, 180px);
  left: clamp(25%, 32%, 40%);
  top: clamp(-6%, 2%, 10%);
  z-index: 25;
  animation: hs-float-cpu 10s ease-in-out 3s infinite backwards;
}

@keyframes hs-float-title {
  0%, 100% { transform: translate3d(0, -5px, 0); }
  50%      { transform: translate3d(0, 5px, 0); }
}
@keyframes hs-float-pc-back {
  0%, 100% { transform: translate3d(0, -6px, 0); }
  50%      { transform: translate3d(0, 6px, 0); }
}
@keyframes hs-float-pc-front {
  0%, 100% { transform: translate3d(0, -8px, 0); }
  50%      { transform: translate3d(0, 8px, 0); }
}
@keyframes hs-float-gpu {
  0%, 100% { transform: translate3d(0, -12px, 0) rotate(-1.5deg); }
  50%      { transform: translate3d(0, 12px, 0) rotate(1.5deg); }
}
@keyframes hs-float-cpu {
  0%, 100% { transform: translate3d(0, -6px, 0) rotate(2deg); }
  50%      { transform: translate3d(0, 6px, 0) rotate(-0.5deg); }
}

.hs-hero.hs-paused .hs-eyebrow-dot,
.hs-hero.hs-paused .hs-hero-title,
.hs-hero.hs-paused .hs-pc-back,
.hs-hero.hs-paused .hs-pc-front,
.hs-hero.hs-paused .hs-part-gpu-main,
.hs-hero.hs-paused .hs-part-cpu {
  animation-play-state: paused;
}

@media (prefers-reduced-motion: reduce) {
  .hs-eyebrow-dot,
  .hs-hero-title,
  .hs-pc-back,
  .hs-pc-front,
  .hs-part-gpu-main,
  .hs-part-cpu {
    animation: none !important;
  }
}

@media (max-width: 425px) {
  .hs-hero {
    min-height: 525px;
  }
}

/* === MOBILE: revert to centered stacked layout (matches hero-light) === */
@media (max-width: 900px) {
  .hs-hero {
    min-height: 488px;
    padding: 1rem 1rem;
  }

  .hs-hero-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem 1rem 0;
    max-width: 1050px;
  }

  .hs-pc-back { left: clamp(8%, 15%, 18%); }
  .hs-pc-front { left: clamp(33%, 48%, 52%); }

  .hs-text-col {
    align-items: center;
    text-align: center;
    width: 100%;
  }

  .hs-hero-title { text-align: center; }

  .hs-hero-buttons {
    margin-top: 1.5rem;
    gap: 1rem;
    justify-content: center;
  }

  .hs-spec-strip {
    justify-content: center;
  }

  .hs-hero-btn {
    padding: 0.7rem 1.5rem;
    font-size: 0.9rem;
  }

  .hs-hardware-cluster {
    width: 100%;
    max-width: 825px;
    height: clamp(260px, 40vh, 375px);
    margin-top: 1rem;
  }

  .hs-pc {
    width: clamp(190px, 40vw, 345px);
  }

  .hs-part-gpu-main {
    width: clamp(195px, 22vw, 270px);
    left: clamp(85%, 90%, 95%);
    top: clamp(-35%, -30%, -25%);
  }

  .hs-part-cpu {
    width: clamp(135px, 16vw, 218px);
    left: clamp(-5%, 0%, 5%);
    top: clamp(5%, 10%, 15%);
  }

  .hs-hero-title-main {
    font-size: clamp(2.8rem, 6vw, 5rem);
  }

  .hs-hero-title-sub {
    font-size: clamp(1.1rem, 2.3vw, 1.7rem);
  }
}

@media (max-width: 769px) {
  .hs-part-cpu,
  .hs-part-gpu-main {
    display: none;
  }

  .hs-pc-back {
    left: clamp(5%, 12%, 16%);
  }

  .hs-pc-front {
    left: clamp(30%, 42%, 48%);
  }
}

@media (max-width: 670px) {
  .hs-pc-back {
    left: clamp(2%, 8%, 12%);
  }

  .hs-pc-front {
    left: clamp(25%, 35%, 45%);
  }
}

@media (max-width: 600px) {
  .hs-hero {
    min-height: 450px;
    padding: 1.2rem 0.5rem;
  }

  .hs-hardware-cluster {
    height: clamp(225px, 35vh, 300px);
    margin-top: 0.5rem;
  }

  .hs-hero-buttons {
    flex-direction: column;
    gap: 0.8rem;
    margin-top: 1rem;
    width: 100%;
    max-width: 300px;
  }

  .hs-hero-btn {
    width: 100%;
    justify-content: center;
    text-align: center;
    padding: 0.8rem 1rem;
  }

  .hs-spec-strip li {
    padding: 0.1rem 0.85rem;
  }

  .hs-spec-label {
    font-size: 0.62rem;
  }

  .hs-spec-value {
    font-size: 0.85rem;
  }

  .hs-slot-gpu { min-width: 16ch; }
  .hs-slot-cpu { min-width: 17ch; }
}

@media (max-width: 430px) {
  .hs-spec-strip li:nth-child(3) {
    display: none;
  }

  .hs-spec-strip li {
    padding: 0.1rem 0.55rem;
  }
}

@media (max-width: 390px) {
  .hs-pc-back {
    left: clamp(-2%, 5%, 10%);
  }

  .hs-pc-front {
    left: clamp(20%, 30%, 38%);
  }
}
